import { ModuleCertificateExtended } from '../models/module-certificate.extended.model';

export class AddModuleCertificates {
    static readonly type = '[ModuleCertificate] AddModuleCertificates';

    constructor(public payload: ModuleCertificateExtended[]) {}
}
